import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';
import { useHomepageTDK } from '~/utils/use-page-tdk';
import Logo from '@lemon8/web-app-shared/logo/square_fullcolor.png';

export const HomepageTwitter = () => {
  const { title, description } = useHomepageTDK();
  const twitterCardInfo = {
    twCardTitle: title,
    twCardDesc: description,
    twCardImageSrc: Logo,
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
